<template>
  <article-section-page :page-size="9" />
</template>

<script setup lang="ts">
  definePageMeta({
    layout: 'default',
    /** 使用固定路由 key，避免在同栏目页内切换分类 Tab 时因路径参数变化导致页面组件重建、Tab 指示器丢失历史定位而无法平滑滑动。 */
    key: 'articles',
    /** 同一一级栏目内的 Tab 切换保留滚动位置；跨一级栏目由列表组件在数据渲染后回顶，跨页面进入仍回顶。 */
    scrollToTop: (to, from) => {
      if (from.name && from.name === to.name) return false
      return true
    },
  })
</script>
